import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { PictureIcon24Regular } from "../../../../../icons2022/FileTypePictureIcon/PictureIcon24Regular";
import { PictureIcon32Regular } from "../../../../../icons2022/FileTypePictureIcon/PictureIcon32Regular";
import { PictureIcon64Regular } from "../../../../../icons2022/FileTypePictureIcon/PictureIcon64Regular";
export var PictureIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(PictureIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(PictureIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(PictureIcon64Regular, null);
  }
}, 'PictureIcon');